import React from 'react';
import {Box, CardContent} from '@mui/material';
import PageWrapper from '@/components/layout/PageWrapper';
import {useTranslation} from 'react-i18next';
import CustomerDataGrid from '@/components/customers/CustomerDataGrid';
import MobileFriendlyCard from "@/components/common/MobileFriendlyCard.tsx";

const Customers = () => {
  const {t} = useTranslation();

  return (
    <PageWrapper title={t('pages.customers.title')}>
      <MobileFriendlyCard sx={{display: 'flex', flex: 1, flexDirection: 'column', overflow: 'hidden'}}>
        <CardContent sx={{p: 2, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden'}}>
          <Box sx={{flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: '400px'}}>
            <CustomerDataGrid/>
          </Box>
        </CardContent>
      </MobileFriendlyCard>
    </PageWrapper>
  );
};

export default Customers;
